module.exports = __webpack_public_path__ + "static/img/WATCH_2_Pro.f005293d.jpg";